import * as Api from '@api/base/public'
import { nameToUpperCase, getNewVisitedViews } from '@utils/store'
import { RESPONSE_SUCCESS } from '@constants'
import * as Types from '../mutation-types'
import { bus } from '@utils/common'

// import { LS } from '@utils/util'
// 初始化缓存数据
const visitedViews = []
// 获取本地国际化json
const lang = localStorage.getItem('lang') || 'EN'
const langJsonStr = localStorage.getItem(`langJson`) || ''
const langJson = langJsonStr && JSON.parse(langJsonStr) || {}

const base = {
  state: {
    httpInstanceList: [], // 请求的实例列表
    user: JSON.parse(localStorage.getItem('userData')) || null, // 用户信息
    isCollapse: false, // menu展开控制
    selectedId: '', // 当前选中编辑、查看行id
    tableHeight: 0,
    systemMenus: JSON.parse(localStorage.getItem('YL_SYSTEM_MENU')), // 系统菜单
    visitedViews, // tag页签
    cachedViews: [], // 需要路由缓存的tag页签
    isUpdateStock: false,
    token: localStorage.getItem('YL_TOKEN') || '',
    lang, // 国际化配置
    langJson,
    langList: JSON.parse(localStorage.getItem('langList') || '[]') // 国家语言列表,

  },
  mutations: {
    // 用户信息
    [Types.SET_USER]: (state, data) => {
      state.user = { ...state.user, ...data }
      localStorage.setItem('userData', JSON.stringify(data))
    },
    // 用户token
    [Types.SET_TOKEN]: (state, data) => {
      state.token = data
      localStorage.setItem('YL_TOKEN', data)
    },
    // 用户系统菜单
    [Types.SET_SYSTEM_MENU]: (state, data) => {
      state.systemMenus = data
      localStorage.setItem('YL_SYSTEM_MENU', JSON.stringify(data))
    },
    // 退出
    [Types.LOGIN_OUT]: state => {
      // 退出登录，清楚本地缓存
      localStorage.removeItem('userData')
      localStorage.removeItem('YL_TOKEN')
      localStorage.removeItem('VISITED_VIEWS')
      localStorage.removeItem('YL_UPDATE')
      localStorage.removeItem('oldPwd')
      localStorage.removeItem('YL_SYSTEM_MENU')
      state.systemMenus = []
      state.token = ''
      state.visitedViews = []
      state.cachedViews = []
      state.user = {}
    },
    [Types.SET_COLLAPSE]: (state, value) => {
      state.isCollapse = value
    },
    [Types.SET_SELECTED_ID]: (state, value) => {
      state.selectedId = value
    },
    [Types.SET_TABLE_HEIGHT]: (state, data) => {
      state.tableHeight = data
    },
    [Types.ADD_VISITED_VIEW]: (state, view = {}) => {
      if (state.visitedViews.some(v => v.name === view.name)) return
      // 加入到tag页签
      state.visitedViews.push(Object.assign({}, view, { title: view.meta.title || 'no-name' }))
      // // 格式化
      const visitedViews = getNewVisitedViews(state.visitedViews)
      // 写入本地缓存
      localStorage.setItem('VISITED_VIEWS', JSON.stringify(visitedViews || '[]'))
    },
    [Types.ADD_CACHED_VIEW]: (state, view) => {
      const name = nameToUpperCase(view.name)
      if (state.cachedViews.includes(name)) return
      if (view.meta.keepAlive) {
        state.cachedViews.push(name)
      }
    },
    [Types.DEL_VISITED_VIEW]: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.name === view.name) {
          state.visitedViews.splice(i, 1)
          const visitedViews = getNewVisitedViews(state.visitedViews)
          localStorage.setItem('VISITED_VIEWS', JSON.stringify(visitedViews || '[]'))
          break
        }
      }
    },
    [Types.DEL_CACHED_VIEW]: (state, view) => {
      for (const i of state.cachedViews) {
        const name = nameToUpperCase(view.name)
        if (i === name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    [Types.DEL_OTHERS_VISITED_VIEWS]: (state, view) => {
      state.visitedViews = state.visitedViews.filter(v => {
        return v.meta.affix || v.name === view.name
      })
      const visitedViews = getNewVisitedViews(state.visitedViews)
      localStorage.setItem('VISITED_VIEWS', JSON.stringify(visitedViews || '[]'))
    },
    [Types.DEL_OTHERS_CACHED_VIEWS]: (state, view) => {
      for (const i of state.cachedViews) {
        const name = nameToUpperCase(view.name)
        if (i === name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, index + 1)
          break
        }
      }
    },
    [Types.DEL_ALL_VISITED_VIEWS]: state => {
      const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
      state.visitedViews = affixTags
    },
    [Types.DEL_ALL_CACHED_VIEWS]: state => {
      state.cachedViews = []
    },
    // 更新面单库存
    [Types.UPDATE_PRINT_STOCK]: (state, value) => {
      state.isUpdateStock = value
    },
    // 国际化
    // 本地langjson 数据
    SET_LANG_JSON: (state, data = {}) => {
      state.langJson = data
      localStorage.setItem('langJson', JSON.stringify(data))
      bus.$emit('langJsonChange', data)
    },
    // 设置国家语言列表
    SET_LANG_LIST: (state, data) => {
      state.langList = data
      localStorage.setItem('langList', JSON.stringify(data))
    },
    // 本地lang
    SET_DEFAULT_LANG: (state, data = {}) => {
      state.lang = data
      localStorage.setItem('lang', data)
    },
    // 设置国际化
    SET_LANG: (state, data) => {
      if (data !== state.lang) {
        localStorage.setItem('lang', data)
        state.lang = data
        setTimeout(() => window.location.reload(), 1500)
      }
    }
  },
  actions: {
    // 登录初始化
    [Types.LOGIN_INIT]({ commit } = {}, value) {
      const { user, token, systemMenus } = value
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      commit('SET_SYSTEM_MENU', systemMenus)
    },
    [Types.SET_SYSTEM_MENU]({ commit } = {}, value) {
      commit('SET_SYSTEM_MENU', value)
    },
    [Types.SET_SELECTED_ID]({ commit } = {}, value) {
      commit('SET_SELECTED_ID', value)
    },
    async [Types.LOGIN_OUT]({ commit } = {}, value) {
      if (value === 'requestError') {
        commit('LOGIN_OUT', value || {})
      } else {
        const { code, msg } = await Api.LOGOUT()
        if (code === RESPONSE_SUCCESS || code === 149010008) {
          commit('LOGIN_OUT', value || {})
        } else {
          console.warn('logout::warn', code, msg)
        }
      }
    },
    [Types.SET_USER]({ commit } = {}, user) {
      commit('SET_USER', user || {})
      commit('SET_TOKEN', user.token)
    },
    [Types.SET_COLLAPSE]({ commit } = {}, value) {
      commit('SET_COLLAPSE', value)
    },
    [Types.SET_TABLE_HEIGHT]: ({ commit } = {}, value) => {
      commit('SET_TABLE_HEIGHT', value)
    },
    [Types.ADD_VIEW]({ dispatch }, view) {
      dispatch('ADD_VISITED_VIEW', view)
      dispatch('ADD_CACHED_VIEW', view)
    },
    [Types.ADD_VISITED_VIEW]({ commit }, view) {
      commit('ADD_VISITED_VIEW', view)
    },
    [Types.ADD_CACHED_VIEW]({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },
    [Types.DEL_VIEW]({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('DEL_VISITED_VIEW', view)
        dispatch('DEL_CACHED_VIEW', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    [Types.DEL_VISITED_VIEW]({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
    [Types.DEL_CACHED_VIEW]({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },
    [Types.DEL_OTHERS_VIEWS]({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('DEL_OTHERS_VISITED_VIEWS', view)
        dispatch('DEL_OTHERS_CACHED_VIEWS', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    // 删除其他tag页
    [Types.DEL_OTHERS_VISITED_VIEWS]({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    // 删除其他tag页路由缓存
    [Types.DEL_OTHERS_CACHED_VIEWS]({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_CACHED_VIEWS', view)
        resolve([...state.cachedViews])
      })
    },
    // 删除所有tag页
    [Types.DEL_ALL_VIEWS]({ dispatch, state }, view) {
      return new Promise(resolve => {
        const oldView = localStorage.getItem('VISITED_VIEWS') ? JSON.parse(localStorage.getItem('VISITED_VIEWS')) : []
        if (view) {
          oldView.map(ele => {
            if (ele.name === view) {
              dispatch('ADD_VISITED_VIEW', ele)
              dispatch('ADD_CACHED_VIEW', ele)
            } else {
              dispatch('DEL_CACHED_VIEW', ele)
              dispatch('DEL_VISITED_VIEW', ele)
            }
          })
          resolve({
            visitedViews: [...state.visitedViews],
            cachedViews: [...state.cachedViews]
          })
        } else {
          dispatch('DEL_ALL_VISITED_VIEWS', view)
          dispatch('DEL_ALL_CACHED_VIEWS', view)
          localStorage.removeItem('VISITED_VIEWS')
          resolve({
            visitedViews: [...state.visitedViews],
            cachedViews: [...state.cachedViews]
          })
        }
      })
    },
    [Types.DEL_ALL_VISITED_VIEWS]({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_VISITED_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    [Types.DEL_ALL_CACHED_VIEWS]({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_CACHED_VIEWS')
        resolve([...state.cachedViews])
      })
    },
    [Types.UPDATE_PRINT_STOCK]({ commit, state }, value) {
      commit('UPDATE_PRINT_STOCK', value)
    },
    // 国际化
    SET_LANG_JSON({ commit }, value) {
      commit('SET_LANG_JSON', value)
    },
    SET_DEFAULT_LANG({ commit }, value) {
      commit('SET_DEFAULT_LANG', value)
    },
    SET_LANG_LIST({ commit }, value) {
      commit('SET_LANG_LIST', value)
    },
    SET_LANG({ commit }, value) {
      commit('SET_LANG', value)
    }
  },
  getters: {
    selectedId: state => state.selectedId,
    lang: state => state.lang,
    langList: state => state.langList,
    isCollapse: state => state.isCollapse,
    tableHeight: state => state.tableHeight,
    user: state => state.user,
    token: state => state.token || '',
    visitedViews: state => state.visitedViews,
    cachedViews: state => state.cachedViews,
    isUpdateStock: state => state.isUpdateStock
  }
}

export default base
